import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TemplateId = Brand<number, 'TemplateId'>;
export const TemplateId = createBranded<TemplateId>();
